import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { finalize, tap } from 'rxjs';
import { SolicitacaoTroca } from 'src/app/models/solicitacao-troca';
import { LoadingService } from 'src/app/services/loading.service';
import { TurnoService } from 'src/app/services/turno/turno.service';

@Component({
  selector: 'app-decline-request-change-scale',
  templateUrl: './decline-request-change-scale.component.html',
  styleUrls: ['./decline-request-change-scale.component.scss'],
})
export class DeclineRequestChangeScaleComponent  implements OnInit {

  @Input() requestData!: SolicitacaoTroca;

  constructor(
    private modalCtrl: ModalController,
    private turnoService: TurnoService,
    private loadingService: LoadingService
  ) { }

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss()
  }

  async confirmOperation() {
    await this.loadingService.presentLoading();
    this.turnoService.recusarSolicitacaoTroca(this.requestData.id.toString())
      .pipe(
        tap(() => {
          this.close();
        }),
        finalize(async () => {
          this.loadingService.dismissLoading();
        })
      )
    .subscribe()

  }

}
